import React, { useState } from 'react';
import { Input, Select, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { QUOTE_STATUSES } from '../constants/statuses';
import { buildQuotesColumns } from '../utils/quotesColumns';
import { useI18n } from '../i18n';

const { Option } = Select;
const { Title } = Typography;

export default function QuotesPage({
  quotes = [],
  leads = [],
  openQuoteDetail,
  openLeadProfile,
  canDelete = true,
}) {
  const { t } = useI18n();
  const [searchText, setSearchText] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const query = searchText.trim().toLowerCase();
  const visibleQuotes = quotes
    .filter((quote) => !quote.archived)
    .filter((quote) => statusFilter === 'all' || quote.status === statusFilter)
    .filter((quote) => (
      !query
      || quote.id.toLowerCase().includes(query)
      || (quote.client || '').toLowerCase().includes(query)
      || (quote.productName || '').toLowerCase().includes(query)
      || (quote.country || '').toLowerCase().includes(query)
    ));

  const columns = buildQuotesColumns({
    t, leads, openQuoteDetail, openLeadProfile, returnView: 'quotes', canDelete,
  });

  return (
    <div>
      <div className="page-toolbar" style={{ marginBottom: '16px' }}>
        <Title level={2} className="page-toolbar-title" style={{ margin: 0 }}>{t('Internal Quotes')}</Title>
        <div className="page-toolbar-controls">
          <Input
            placeholder={t('Search by quote ID, customer or product...')}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 300, height: 32, display: 'flex', alignItems: 'center' }}
            suffix={<SearchOutlined />}
          />
          <Select value={statusFilter} onChange={setStatusFilter} style={{ width: 170 }}>
            <Option value="all">{t('All Statuses')}</Option>
            {QUOTE_STATUSES.map((status) => <Option key={status} value={status}>{t(status)}</Option>)}
          </Select>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={visibleQuotes}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination={{ pageSize: 10, position: ['bottomCenter'] }}
        bordered
        size="middle"
        locale={{ emptyText: t('No quotes match') }}
      />
    </div>
  );
}
